import { render, staticRenderFns } from "./FormVendor.vue?vue&type=template&id=36456b9a"
import script from "./FormVendor.vue?vue&type=script&lang=js"
export * from "./FormVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports